export default {
  SET_CURRENCY_SETTING(state, results) {
    state.currencySetting = results;
  }
};
